// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__idhr3","approved":"Status_approved__bw0MT","rejected":"Status_rejected__1mr-J","expired":"Status_expired__XuxIl","label":"Status_label__Z21_w"};